import clsx from 'clsx';
import { FC } from 'react';

import Button from '~components/generic/elements/Button';

export interface IToggleCodeButtonProps {
  onClick: () => void;
  isOn: boolean;
}

const ToggleCodeButton: FC<IToggleCodeButtonProps> = ({ onClick, isOn }) => {
  return (
    <Button
      className={clsx('u-size-xs c-button u-margin-left-md u-padding-horizontal-md', {
        'c-button--light': !isOn,
        'c-button--dark': isOn,
      })}
      name="ui-component-code-toggle"
      label="Toggle source code"
      title="Toggle source code"
      hideLabel={true}
      iconName="code"
      iconCentered={false}
      onClick={onClick}
    />
  );
};

export default ToggleCodeButton;
